module.exports = __webpack_public_path__ + "img/Opty.c23f428a.svg";